import { ConfirmMoneyMiniBC, CountMoneyMiniBC, ParamBetMiniBC, PayloadBodyTopicBC, TypePlaceMiniBC } from 'models/mini-bc-model';
import './board-bc.scss';
import { ChipItem, PayloadBodyUserQueueTXCB } from 'models/txcb-model';
import { forwardRef, useEffect, useMemo, useRef, useState } from 'react';
import { SwiperClass } from 'swiper/react';
import { chipMiniGameList, reloadBalance } from 'utils/function';
import { default as bcFunction, default as xdFunction } from './bc-function';
import ReactDOMServer from 'react-dom/server';
import bgAudio from 'assets/images/audio/background.mp3';
import bgAudioStart from 'assets/images/audio/voiceStartBet.mp3';
import bgAudioStop from 'assets/images/audio/voiceStopBet.mp3';
import ChipsBaucua from './chips-baucua';
import TimerMiniBC from './timer-mini-bc';
import PlaceBetBC from './place-bet-bc/place-bet-bc';
import { FaWallet } from 'react-icons/fa6';
import PlateBowBC from './plate-bow-bc';

interface Props {
    balance: string;
    bodyTopic: PayloadBodyTopicBC;
    userQueue: PayloadBodyUserQueueTXCB;
    onBet: (action: string, payload: ParamBetMiniBC) => void;
    onUpdatePhien: (value: { id: number; result: number[] }[]) => void;
    lspData: { id: number; result: number[] }[];
    isMuted: boolean;
    onChangeMsg: (inputData: string) => void;
}
function BoardBC(props: Props, ref: any) {
    const { balance, bodyTopic, userQueue, onBet, onUpdatePhien, lspData, isMuted, onChangeMsg } = props;
    let chipStoreBet = useRef<HTMLSpanElement[]>([]);
    let objAudio = useMemo(() => new Audio(), []);
    const backgroundAudio = useMemo(() => new Audio(bgAudio), []);

    let paramsBet: ParamBetMiniBC = useMemo(
        () => ({
            baucuaId: 0,
            nai: 0,
            cua: 0,
            ga: 0,
            tom: 0,
            bau: 0,
            ca: 0,
            userId: 0,
            loginname: '',
            total_amount: 0,
            userType: 0,
            betfrom: 0,
        }),
        []
    );

    const timerFinishRef = useRef<HTMLDivElement>(null);
    const chipsListRef = useRef<any[]>([]);
    const swiperRef = useRef<SwiperClass>();
    const isNextPhien = useRef(false);

    const [timerCount, setTimerCount] = useState('00');
    const [timerFinish, setTimerFinish] = useState('');
    const [issue, setIssue] = useState(0);
    const [isTimerCount, setIsTimerCount] = useState(true);

    const [result, setResult] = useState<number[] | null>(null);
    const [chipValue, setChipValue] = useState(1000);

    const [dealerState, setDealerState] = useState<'STOP' | 'START' | ''>('');

    const [tkBoardList, setTkBoardList] = useState<{ id: string; result: number[] }[]>([]);

    const [moneyCountPlace, setMoneyCountPlace] = useState({} as CountMoneyMiniBC); // tổng cược của từng cửa
    const moneyWin = useRef<number>(0);
    const isShowingWin = useRef(false);

    const updateMoneyWin = (value: number) => {
        moneyWin.current = value;
    };

    const [countConfirmBet, setCountConfirmBet] = useState({
        moneyConfirmNai: 0,
        moneyConfirmBau: 0,
        moneyConfirmCua: 0,
        moneyConfirmTom: 0,
        moneyConfirmCa: 0,
        moneyConfirmGa: 0,
    } as ConfirmMoneyMiniBC); //tiền đã cược của tôi các cửa
    const [totalCurrentBet, setTotalCurrentBet] = useState(0);

    useEffect(() => {
        if (isMuted) {
            backgroundAudio.pause();
        } else {
            backgroundAudio.play();
            backgroundAudio.volume = 0.5;
            backgroundAudio.loop = true;
        }
    }, [isMuted]);

    useEffect(() => {
        backgroundAudio.play();
        backgroundAudio.volume = 0.5;
        backgroundAudio.loop = true;

        return () => backgroundAudio.pause();
    }, []);

    useEffect(() => {
        //bắt đầu phiên mới
        if (bodyTopic.cmd === 1) {
            paramsBet.baucuaId = bodyTopic.id;
            setIsTimerCount(true);
            setResult(null);
            setIssue(bodyTopic.id);
            setTimerFinish('');

            setMoneyCountPlace({
                moneyCountNai: bodyTopic.aDeer,
                moneyCountCua: bodyTopic.aCrab,
                moneyCountGa: bodyTopic.aChicken,
                moneyCountCa: bodyTopic.aFish,
                moneyCountTom: bodyTopic.aShrimp,
                moneyCountBau: bodyTopic.aGourd,
            });

            //thời gian cược
            setTimerCount(`0${bodyTopic.cd}`.slice(-2));
        }

        //kết quả phiên và hiệu ứng mở thưởng
        if (bodyTopic.cmd === 5 && bodyTopic.cd === -1) {
            // console.log(bodyTopic);
            dealerSpeak('STOP');
            let hisPhien = lspData;
            const lspLast = { id: bodyTopic['id'], result: bodyTopic['rs'] || [] };
            hisPhien = [lspLast, ...hisPhien];
            hisPhien.pop();
            onUpdatePhien(hisPhien);
            setResult(bodyTopic.rs);
        }

        //count finish phiên
        if (bodyTopic.cmd === 2 && bodyTopic.cd <= 14) {
            setTimerFinish(`0${bodyTopic.cd}`.slice(-2));
            setIsTimerCount(false);
            if (timerFinishRef.current) {
                timerFinishRef.current.style.transform = 'scale(1.25)';
                setTimeout(() => {
                    if (timerFinishRef.current) {
                        timerFinishRef.current.style.transform = 'scale(1)';
                    }
                }, 160);
            }
            if (bodyTopic.cd === 0) {
                handleGetMsg('Bắt đầu phiên mới');
                dealerSpeak('START');
                setCountConfirmBet({
                    moneyConfirmNai: 0,
                    moneyConfirmBau: 0,
                    moneyConfirmCua: 0,
                    moneyConfirmTom: 0,
                    moneyConfirmCa: 0,
                    moneyConfirmGa: 0,
                });
                updateMoneyWin(0);
                isShowingWin.current = false;
            }
        }
        isNextPhien.current = false;
        if (bodyTopic.cmd === 2 && bodyTopic.cd <= 17) {
            isNextPhien.current = true;
        }
    }, [bodyTopic]);

    useEffect(() => {
        if (userQueue.cmd === 3) {
            //bắt đầu cược
            if (userQueue.status === 0) {
                handleGetMsg('Đặt cược thành công');
                setCountConfirmBet((value) => {
                    return {
                        moneyConfirmNai: (value.moneyConfirmNai += paramsBet.nai),
                        moneyConfirmBau: (value.moneyConfirmBau += paramsBet.bau),
                        moneyConfirmCa: (value.moneyConfirmCa += paramsBet.ca),
                        moneyConfirmCua: (value.moneyConfirmCua += paramsBet.cua),
                        moneyConfirmGa: (value.moneyConfirmGa += paramsBet.ga),
                        moneyConfirmTom: (value.moneyConfirmTom += paramsBet.tom),
                    };
                });
                if (ref.current) {
                    chipStoreBet.current = Array.from(ref.current.querySelectorAll('.chipEmbed'));
                }
                resetBet();
                reloadBalance();
            }
        }

        // START return money win if has betting
        if (userQueue.cmd === 4 && userQueue.amount > 0 && !isShowingWin.current) {
            isShowingWin.current = true;
    
            setTimeout(() => {
                updateMoneyWin(userQueue.amount);
                setTimeout(() => {
                    updateMoneyWin(0);
                }, 3000)
            }, 3500);
        }

        //bắt đầu lịch sử phiên
        if (userQueue.cmd === 6) {
            const listHisPhien = userQueue.data
                .filter((item) => item.result !== null)
                .map((item) => {
                    return {
                        id: Number(item['id']),
                        result: item['result'].split('').map(Number),
                    };
                })
                .slice(0, 75);
            onUpdatePhien(listHisPhien);

            const listDotHisPhien: { id: string; result: number[] }[] = JSON.parse(JSON.stringify(listHisPhien))
                .filter((_: any, idx: number) => idx < 10)
                .reverse();
            setTkBoardList(listDotHisPhien);
        }
    }, [userQueue]);

    const renderHTMLChip = (item: ChipItem) => {
        return (
            <div style={{ cursor: 'unset' }} className="chip-item">
                <img src={require(`assets/images/chips/${item.icon}`)} alt="" />
                <p>{item.txt}</p>
            </div>
        );
    };

    const selectChip = (chipSelect: ChipItem) => {
        setChipValue(chipSelect.val);
    };

    const selectTypeBet = (placeEl: HTMLButtonElement, typeBet: TypePlaceMiniBC) => {
        xdFunction.playClick(objAudio);
        if (isNextPhien.current) {
            handleGetMsg('Phiên mới chưa bắt đầu');
            return;
        }
        if (totalCurrentBet + chipValue > Number(balance)) {
            handleGetMsg('Số dư không đủ');
            return;
        }

        setTotalCurrentBet((value) => (value += chipValue));

        const chipSelect = chipMiniGameList.find((item) => item.val === chipValue);
        const chipIdxSelect = chipMiniGameList.findIndex((item) => item.val === chipValue);
        if (swiperRef.current) {
            swiperRef.current.slideTo(chipIdxSelect);
        }
        if (chipSelect) {
            //chip effect bet
            const chipCloneJXS = renderHTMLChip(chipSelect);
            const htmlString = ReactDOMServer.renderToStaticMarkup(chipCloneJXS);
            if (ref.current) {
                bcFunction.effectChipBet(htmlString, ref.current, chipsListRef.current, placeEl, typeBet, chipSelect.val, 0.6);
            }
        }

        paramsBet[typeBet] += chipValue;

        paramsBet.betfrom = 3;
        const totalAmount = paramsBet.bau + paramsBet.cua + paramsBet.tom + paramsBet.ca + paramsBet.ga + paramsBet.nai;
        paramsBet.total_amount = totalAmount;
    };

    const cancelBet = () => {
        xdFunction.playClick(objAudio);
        resetBet();
    };

    const rebet = () => {
        xdFunction.playClick(objAudio);
        const newMoneyCountPlace: CountMoneyMiniBC = JSON.parse(JSON.stringify(moneyCountPlace));
        let totalBet = 0;
        chipStoreBet.current.forEach((item) => {
            const keyTypeBet = item.dataset.typebet;
            const chipValueText = item.querySelector('ion-text')?.innerHTML;

            let chipValue = 0;
            if (chipValueText) {
                if (chipValueText.includes('K')) {
                    chipValue = Number(chipValueText.replace('K', '')) * 1000;
                } else if (chipValueText.includes('M')) {
                    chipValue = Number(chipValueText.replace('M', '')) * 1000000;
                }
            }

            if (keyTypeBet === 'bau') {
                paramsBet.bau += chipValue;
                newMoneyCountPlace.moneyCountBau += chipValue;
                totalBet += chipValue;
            } else if (keyTypeBet === 'cua') {
                paramsBet.cua += chipValue;
                newMoneyCountPlace.moneyCountCua += chipValue;
                totalBet += chipValue;
            } else if (keyTypeBet === 'tom') {
                paramsBet.tom += chipValue;
                newMoneyCountPlace.moneyCountTom += chipValue;
                totalBet += chipValue;
            } else if (keyTypeBet === 'ca') {
                paramsBet.ca += chipValue;
                newMoneyCountPlace.moneyCountCa += chipValue;
                totalBet += chipValue;
            } else if (keyTypeBet === 'ga') {
                paramsBet.ga += chipValue;
                newMoneyCountPlace.moneyCountGa += chipValue;
                totalBet += chipValue;
            } else if (keyTypeBet === 'nai') {
                paramsBet.nai += chipValue;
                newMoneyCountPlace.moneyCountNai += chipValue;
                totalBet += chipValue;
            }
        });

        setTotalCurrentBet(totalBet);
        setMoneyCountPlace(newMoneyCountPlace);

        chipStoreBet.current.forEach((item) => {
            if (ref.current) {
                const elBtnTypeBet: HTMLButtonElement = ref.current.querySelector(`[data-infinity="${item.dataset.typebet}"]`);
                elBtnTypeBet.appendChild(item);
            }
        });
    };

    const handleGetMsg = (msg: any) => {
        onChangeMsg(msg);
    };

    const betting = () => {
        xdFunction.playClick(objAudio);
        if (isNextPhien.current) {
            handleGetMsg('Phiên mới chưa bắt đầu');
            return;
        }
        if (totalCurrentBet === 0) {
            handleGetMsg('Vui lòng chọn cửa cược');
            return;
        }
        onBet('/topic/bc/bet', JSON.parse(JSON.stringify(paramsBet)));
    };

    const resetBet = async () => {
        setTotalCurrentBet(0);
        paramsBet.bau = 0;
        paramsBet.cua = 0;
        paramsBet.tom = 0;
        paramsBet.ca = 0;
        paramsBet.ga = 0;
        paramsBet.nai = 0;

        //clear chip dom
        if (ref.current) {
            const listCurrentChip = Array.from(ref.current.querySelectorAll('.chipEmbed'));
            listCurrentChip.forEach((element: any) => {
                element.remove();
            });
        }
    };

    const dealerSpeak = (type: 'START' | 'STOP') => {
        setDealerState(type);
        if (!isMuted) {
            if (type === 'START') {
                xdFunction.dealerSpeak(objAudio, bgAudioStart);
            } else {
                xdFunction.dealerSpeak(objAudio, bgAudioStop);
            }
        }
        setTimeout(() => {
            setDealerState('');
        }, 1600);
    };

    return (
        <div className="board-bc-container">

            <div className={`moneyWin ${moneyWin.current !== 0 ? "showMoney" : ""}`} >
                <span>+{moneyWin.current.toLocaleString()}</span>
            </div>

            <div className="table-bet">
                <div className="dealer-voice">
                    <div className="voice-inner">
                        {dealerState === 'START' && <img src={require(`assets/images/mini-xd/start-bet.png`)} />}
                        {dealerState === 'STOP' && <img src={require(`assets/images/mini-xd/stop-bet.png`)} />}
                    </div>
                </div>
                <img className="table-img" src={require(`assets/images/mini-bc/table.png`)} />
                <div className="bet-content">
                    <div className="plate-bow">
                        <PlateBowBC result={result} moneyWinBC={moneyWin.current} timerCount={timerCount} timerFinish={timerFinish} />
                    </div>
                    <div className="place-wrap">
                        <div className="moneybet">
                            <div className="wallet-xd">
                                <div className="wallet-item">
                                    <FaWallet size={12} color="white" />
                                    <p className="text-gradient">{new Intl.NumberFormat().format(Number(balance || 0))}</p>
                                </div>
                            </div>
                            <div></div>
                            <div className="wallet-xd">
                                <div className="wallet-item">
                                    <p className="text-gradient">#{issue}</p>
                                </div>
                            </div>
                        </div>
                        <img className="bg-place" src={require(`assets/images/mini-bc/bg-place.png`)} />
                        <div className="place-content">
                            <TimerMiniBC showCountBet={isTimerCount} finishTimerCount={timerFinish} timerCount={timerCount} />
                            <PlaceBetBC
                                moneyCount={moneyCountPlace}
                                moneyConfirm={countConfirmBet}
                                issue={issue}
                                result={result}
                                onSelectBet={selectTypeBet}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className="chips-minigame">
                <ChipsBaucua ref={chipsListRef} valueActive={chipValue} onSelect={selectChip} />
            </div>
            <div className="footer-action">
                <div className="footer-gird">
                    <div className="footer-row">
                        <div className="footer-col">
                            <button className="btn-reset btn-action" onClick={cancelBet}>
                                <img className="action-icon" src={require(`assets/images/mini-xd/btn-clear.png`)} />
                            </button>
                        </div>
                        <div className="footer-col footer-bet">
                            <button className="btn-reset btn-bet" onClick={betting}>
                                <p>
                                    CƯỢC: <span>{new Intl.NumberFormat().format(totalCurrentBet)}</span>
                                </p>
                            </button>
                        </div>
                        <div className="footer-col">
                            <button className="btn-reset btn-action" onClick={rebet}>
                                <img className="action-icon" src={require(`assets/images/mini-xd/btn-rebet.png`)} />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default forwardRef(BoardBC);
